document.addEventListener('ShoptetDOMAdvancedOrderLoaded', function() {  
    $('.h1.advanced-order-suggestion').text('Doporučujeme přikoupit')
})


document.addEventListener('ShoptetDOMCartContentLoaded', function() { 
    
    $('.cart-widget-product').each(function(){
        $(this).find('.cart-widget-product-name').append('<span class="amountProduct">'+$(this).find('.cart-widget-product-amount input.amount').val()+' '+$(this).find('.cart-widget-product-unit').text()+'</span>')
        var $row=$(this);
        var $surcharges=$row.find('.cart-widget-product-surcharges');
        if($surcharges.length){
                var surchargeText=$surcharges.text();
                var surchargeItems=surchargeText.match(/Příplatky:[^1-9]+-\s*\d+/g);
                if(surchargeItems){
                    var surchargeHtml='<div class="surcharge-images">';
                    surchargeItems.forEach(function(item){
                        var trimmedItem=$.trim(item);
                        var textTooltip=trimmedItem.split('-')[1]?trimmedItem.split('-')[1].trim():'';
                        textTooltip=textTooltip.replace(/,\s*$/,'');
                        var normalizedItem=trimmedItem.normalize("NFD").replace(/[\u0300-\u036f]/g,"");
                        var firstPart=normalizedItem.split('-')[1]?normalizedItem.split('-')[1].trim():normalizedItem.trim();
                        var imageName=firstPart.toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'')+'.jpg';
                        var imagePath='/user/documents/upload/detail-nemazat/parametry/'+imageName;
                        var imgTag='<img src="'+imagePath+'" alt="'+trimmedItem+'" onerror="this.parentElement.classList.remove(\'has-image\');this.outerHTML=\''+trimmedItem+'\'">';
                        surchargeHtml+='<div class="surcharge-item has-image show-tooltip" title="'+textTooltip+'" data-title="'+textTooltip+'">'+imgTag+'</div>';
                    });
                    surchargeHtml+='</div>';
                    $surcharges.after(surchargeHtml);
                }
        }

    })

})

if($('.id--16, .id--17').length){
    $.get('/action/Cart/GetCartContent/?orderingProcessActive=1', function(data){   
        $('.cart-item[data-micro="cartItem"]').each(function(){
            get_id = $(this).attr('data-micro-sku')
             var $row=$(this);
            link = $(data.payload.content).find('.removeable[data-micro-sku="'+get_id+'"] .cart-p-image a').attr('href')
            image = $(data.payload.content).find('.removeable[data-micro-sku="'+get_id+'"] .cart-p-image img').attr('data-src').replace('related', 'detail')
            if(!$(this).find('.right').length){
                $(this).wrapInner('<div class="right"></div>')
                $(this).prepend('<div class="image"><a href="'+link+'"><img src="'+image+'" alt="'+$(this).find('a[data-testid="recapItemName"]').text()+'"></a></div>')
            }
            var $surcharges=$row.find('.main-link-surcharges');
            if($surcharges.length){
                var surchargeText=$surcharges.text();
                var surchargeItems=surchargeText.match(/Příplatky:[^1-9]+-\s*\d+/g);
                if(surchargeItems){
                    var surchargeHtml='<div class="surcharge-images">';
                    surchargeItems.forEach(function(item){
                        var trimmedItem=$.trim(item);
                        var textTooltip=trimmedItem.split('-')[1]?trimmedItem.split('-')[1].trim():'';
                        textTooltip=textTooltip.replace(/,\s*$/,'');
                        var normalizedItem=trimmedItem.normalize("NFD").replace(/[\u0300-\u036f]/g,"");
                        var firstPart=normalizedItem.split('-')[1]?normalizedItem.split('-')[1].trim():normalizedItem.trim();
                        var imageName=firstPart.toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'')+'.jpg';
                        var imagePath='/user/documents/upload/detail-nemazat/parametry/'+imageName;
                        var imgTag='<img src="'+imagePath+'" alt="'+trimmedItem+'" onerror="this.parentElement.classList.remove(\'has-image\');this.outerHTML=\''+trimmedItem+'\'">';
                        surchargeHtml+='<div class="surcharge-item has-image show-tooltip" title="'+textTooltip+'" data-title="'+textTooltip+'">'+imgTag+'</div>';
                    });
                    surchargeHtml+='</div>';
                    $surcharges.after(surchargeHtml);
                }
            }

            var stored=JSON.parse(localStorage.getItem('mhCustomTexts')||'{}');
            var code = $row.data('micro-sku');
            if(stored[code]&&stored[code].length){
                var listHtml=stored[code].map(function(txt,i){
                    return `<li data-index="${i}">${txt}<span class="delete" title="Smazat text">×</span></li>`;
                }).join('');
                $row.find('.cart-item-name').append(`
                    <div class="customTextInfo">
                        <strong>Texty k produktu:</strong>
                        <ul>${listHtml}</ul>
                    </div>
                `);
            }
            var countInCart=parseInt($row.find('input.amount').val())||0;
            var countStored=(stored[code]?stored[code].length:0);
         /*   if(countInCart!==countStored){
                if(!$('.custom-text-warning').length){
                    $('.next-step.next-step--cart').after(`
                        <div class="custom-text-warning">
                            ${cardWarning}
                        </div>
                    `);
                }
                $row.addClass('has-text-mismatch');
            }*/

        })
    })
    $('.cart-inner').prepend($('.cart-header'))
}

if($('.id--9').length){
    function mhProductInfoMove(){
        $('.cart-table tr').each(function(){
            var $row=$(this);
            var findcenazakus=$row.find('.p-price.p-cell').html();
            var findptotal=$row.find('.p-total');
            $row.find('.p-name').append('<div class="avail">'+$row.find('.p-availability').html()+'</div>');
            $(findptotal).prepend('<span class="cenazaks">'+findcenazakus+'</span>');
            var $surcharges=$row.find('.main-link-surcharges');
            if($surcharges.length){
                var surchargeText=$surcharges.text();
                var surchargeItems=surchargeText.match(/Příplatky:[^1-9]+-\s*\d+/g);
                if(surchargeItems){
                    var surchargeHtml='<div class="surcharge-images">';
                    surchargeItems.forEach(function(item){
                        var trimmedItem=$.trim(item);
                        var textTooltip=trimmedItem.split('-')[1]?trimmedItem.split('-')[1].trim():'';
                        textTooltip=textTooltip.replace(/,\s*$/,'');
                        var normalizedItem=trimmedItem.normalize("NFD").replace(/[\u0300-\u036f]/g,"");
                        var firstPart=normalizedItem.split('-')[1]?normalizedItem.split('-')[1].trim():normalizedItem.trim();
                        var imageName=firstPart.toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'')+'.jpg';
                        var imagePath='/user/documents/upload/detail-nemazat/parametry/'+imageName;
                        var imgTag='<img src="'+imagePath+'" alt="'+trimmedItem+'" onerror="this.parentElement.classList.remove(\'has-image\');this.outerHTML=\''+trimmedItem+'\'">';
                        surchargeHtml+='<div class="surcharge-item has-image show-tooltip" title="'+textTooltip+'" data-title="'+textTooltip+'">'+imgTag+'</div>';
                    });
                    surchargeHtml+='</div>';
                    $surcharges.after(surchargeHtml);
                }
            }

            var stored=JSON.parse(localStorage.getItem('mhCustomTexts')||'{}');
            var code=$row.data('micro-sku');
            if(stored[code]&&stored[code].length){
                var listHtml=stored[code].map(function(txt,i){
                    return `<li data-index="${i}">${txt}<span class="delete" title="Smazat text">×</span></li>`;
                }).join('');
                $row.find('.p-name').append(`
                    <div class="customTextInfo">
                        <strong>Texty k produktu:</strong>
                        <ul>${listHtml}</ul>
                    </div>
                `);
            }
            var countInCart=parseInt($row.find('input.amount').val())||0;
            var countStored=(stored[code]?stored[code].length:0);
            if(countInCart!==countStored){
              /*  if(!$('.custom-text-warning').length){
                    $('.next-step.next-step--cart').after(`
                        <div class="custom-text-warning">
                            ${cardWarning}
                        </div>
                    `);
                }*/
                $row.addClass('has-text-mismatch');
            }
        });

    };
    mhProductInfoMove()
    document.addEventListener('ShoptetDOMCartContentLoaded', function () {
        mhProductInfoMove();
    });
}

if($('.id--17').length){
//    $('.cart-content>.co-contact-information .phone-form-group').after($('.form-group label[for="login"]').closest('.form-group'))
}


if($('.ordering-process').length){
    $(document).ready(function () {
        if(sessionStorage.footer) {
          $('.overall-wrapper').append(sessionStorage.footer);
          
      //    mhmove();
        } else {
          $.ajax({
            type: "GET",
            dataType: "html",
            timeout: 1e4,
            cache: !0,
            url: "/",
            success: function(e) {
                var a = shoptet.common.createDocumentFromString(e),
                t = $(a).find("#footer#footer").html();
                null !== t && ('<footer id="footer">'+t+'</footer>'), 
                $('.overall-wrapper').append('<footer id="footer">'+t+'</footer>'); //mhmove();
                sessionStorage.footer = ('<footer id="footer">'+t+'</footer>');
          
                }
            }).done(function(){
            });
        }
    })
}

$('html').on('click','.customTextInfo .delete',function(){
    var $li=$(this).closest('li');
    var index=$li.data('index');
    var $row=$li.closest('tr');
    var code=$row.data('micro-sku');
    var stored=JSON.parse(localStorage.getItem('mhCustomTexts')||'{}');
    if(stored[code]){
        stored[code].splice(index,1);
        if(stored[code].length===0)delete stored[code];
        localStorage.setItem('mhCustomTexts',JSON.stringify(stored));
    }
    $li.remove();
   // $('.custom-text-warning').remove();
    $('.cart-table tr').removeClass('has-text-mismatch');
    $('.cart-table tr').each(function(){
        var $row=$(this);
        var code=$row.data('micro-sku');
        var countInCart=parseInt($row.find('input.amount').val())||0;
        var countStored=(stored[code]?stored[code].length:0);
        if(countInCart!==countStored){
           /* if(!$('.custom-text-warning').length){
                $('.next-step.next-step--cart').after(`
                    <div class="custom-text-warning">
                        ${cardWarning}
                    </div>
                `);
            }*/
            $row.addClass('has-text-mismatch');
        }
    });
});

if($('.id--17').length){

    shoptet.scripts.setCustomFunction("postSuccessfulValidation", function(form, args) {
        if ($(form).attr("id") === "order-form") {
            UlozitPoznamku();
        }
        return true;
    });

}
function UlozitPoznamku() {
    // Načti uložené texty
    var savedTexts = localStorage.getItem('mhCustomTexts');
    if (!savedTexts) return;
    
    savedTexts = JSON.parse(savedTexts);
    var noteText = '';

    // Projdi všechny položky v košíku
    $('.cart-items .cart-item').each(function() {
        var $item = $(this);
        var sku = $item.data('micro-sku'); // např. "551/5 C"
        if (sku && savedTexts[sku] && savedTexts[sku].length) {
            var texts = savedTexts[sku].join(', ');
            var productName = $.trim($item.find('.cart-item-name a.main-link').text()) || sku;
            
            noteText += "Produkt: " + productName + " (" + sku + ")\n";
            noteText += "Texty k produktu: " + texts + "\n\n";
        }
    });

    if (!noteText.length) return;

    // Najdi pole poznámky
    var $remark = $('#remark, #note, textarea[name="note"], textarea[name="comment"]');
    if (!$remark.length) return;

    // Připoj text do poznámky
    var actText = $.trim($remark.val());
    if (actText.length > 0) {
        actText += "\n\n";
    }

    $remark.val(actText + noteText);
}